import React from "react";
import { Box, Typography } from "@bca/ui-library";
import styled from "styled-components";

import PricingAndVATProps from "./PricingAndVAT.type";
import media from "../media";
import { formatPrice } from "./PricingAndVAT";
import HPISpecCheck from "./HPISpecCheck";

const PricingBox = styled(Box)`
  display: none;
  ${media.tablet} {
    display: flex;
  }
`;

const PricingAndVATTablet: React.FunctionComponent<PricingAndVATProps> = ({
  saleChannel,
  buyNowPrice,
  capClean,
  vatType,
  currentBid,
  hpi,
  HPISpecCheckLink,
  vehicleAnalytics,
}) => {
  return (
    <PricingBox display="flex" width="100%">
      <Box
        display="flex"
        css={`
          gap: 20px;
          flex: 1 1 0;
        `}
      >
        {Boolean(hpi) && (
          <Box display="flex" flexDirection="column">
            <HPISpecCheck
              starRating={hpi.optionsRating}
              price={hpi.optionsPrice}
              anchorLink={HPISpecCheckLink}
              vehicleAnalytics={vehicleAnalytics}
            />
          </Box>
        )}
        {Boolean(capClean) && (
          <Box
            display="flex"
            flexDirection="column"
            alignItems="flex-start"
            flexBasis="104px"
          >
            <Typography variant="body-small" color="grey-blue" m={0}>
              CAP Clean
            </Typography>
            <Typography variant="body-small" color="grey-blue" m={0}>
              {capClean}
            </Typography>
          </Box>
        )}
        <Typography variant="body-small" color="grey-blue" m={0}>
          {vatType}
        </Typography>
      </Box>
      <Box
        display="flex"
        css={`
          gap: 20px;
        `}
      >
        {saleChannel === "Tender" && Boolean(currentBid) && (
          <Box
            display="flex"
            flexDirection="column"
            alignItems="flex-end"
            minWidth="104px"
          >
            <Typography variant="body-small" color="grey-blue" m={0}>
              Current Bid
            </Typography>
            <Typography variant="body-small" color="grey-blue" m={0}>
              {formatPrice(currentBid)}
            </Typography>
          </Box>
        )}
        {saleChannel !== "InternetAuction" && Boolean(buyNowPrice) && (
          <Box
            display="flex"
            flexDirection="column"
            alignItems="flex-end"
            minWidth="104px"
          >
            <Typography
              variant="body"
              color="footer-blue"
              fontWeight="semiBold"
              m={0}
            >
              Buy Now
            </Typography>
            <Typography variant="h5" m={0}>
              {buyNowPrice}
            </Typography>
          </Box>
        )}
      </Box>
    </PricingBox>
  );
};

export default PricingAndVATTablet;
